import React from "react";

const WorkspaceListShimmer = () => {
  return (
    <div className="community-card-grid" role="status" aria-label="Loading channels">
      {[0, 1, 2].map(key => <div key={key} aria-hidden="true" className="community-card directory-skeleton">
        <div className="community-card-cover" />
        <div className="community-card-body"><span /><span /><span /></div>
      </div>)}
    </div>
  );
};

export default WorkspaceListShimmer;
